"use client";
import Image from "next/image";
import { imageKitLoader } from "@/utils/imageKitLoader";

// Server components cannot pass a function prop (custom loader) to
// next/image — partner logos and city photos render through this client
// wrapper so any image host works without next.config changes.
const PartnerImage = ({ alt = "", ...props }) => (
  <Image loader={imageKitLoader} alt={alt} {...props} />
);

export default PartnerImage;
